/** API origin from the runtime config (public/config.js), so one image serves every environment. */
export const API_URL = (window.__ARTIMAN_PANEL__?.apiUrl || 'http://localhost:3001').replace(/\/$/, '');
/** Public website origin ("view on site" links). */
export const SITE_URL = (window.__ARTIMAN_PANEL__?.siteUrl || 'http://localhost:3000').replace(/\/$/, '');
